module.exports = __webpack_public_path__ + "502eb5b1872c609c428193574eeb18c2.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1149
// module chunks = 0